<!-- 留言咨询-编辑 -->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container">
      <!--基本信息-->
      <p style="margin-top: 0;text-align: left;border-bottom: 1px dashed #616161;padding-bottom: 2px">
        {{ $t('Common.basicInfomation') }}</p>
      <el-form ref="dataForm" :rules="dataFormRules" size="small" label-width="auto" label-position="right" :model="formQuery">
        <el-form-item :label="$t('icInformation.inforType') + ':'" prop="inforType">
          <el-select v-model="formQuery.inforType">
            <el-option v-for="item in inforTypeList" :key="item.code" :label="$lt(initDict.infortype, item.code)"
                       :value="item.code"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('icInformation.title') + ':'" prop="title">
          <el-input v-model.trim="formQuery.title" style="width:400px;"/>
        </el-form-item>
        <el-form-item :label="$t('icInformation.content') + ':'" prop="content">
          <el-input type="textarea" :rows="10" v-model="formQuery.content"/>
        </el-form-item>
        <el-form-item label-width="0">
          <div style="text-align: center">
            <el-button :loading="loading" type="primary" @click="onPosSubmit">{{ this.$t('button.save') }}</el-button>
            <el-button type="default" @click="onBack">{{ this.$t('operation.button.return') }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import {informationEdit} from "@/api/ic/icInformation";

export default {
  name: 'EditAdvisoryMessage',
  components: {},
  data() {
    return {
      activeName: 'first',
      loading: false,
      total: 0,
      dataFormRules: {
        inforType:[{required: true, message: ' ', trigger: 'blur'}],
        title:[{required: true, message: ' ', trigger: 'blur'}],
        content:[{required: true, message: ' ', trigger: 'blur'}],
      },
      formQuery: {
        inforType: null,
        title: null,
        content: null,
      },
      initDict: {
        infortype: 'type.infortype.cn'
      }
    }
  },
  computed: {
    inforTypeList() {
      return this.$ll(this.initDict.infortype)
    }
  },
  created() {
    if (this.$route.params.content) {
      this.formQuery = this.$route.params.content
      this.formQuery.inforType = this.$route.params.content.inforType.toString()
    }
  },
  methods: {
    onBack() {
      this.$router.go(-1)
    },
    onPosSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          informationEdit(this.formQuery).then((res) => {
            if (res.success) {
              this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
              this.$router.push({ name: 'AdvisoryMessage' })
            }
            this.loading = false
          }).catch(err => {
            console.warn(err)
            this.loading = false
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>